var $ = require("jquery");
require("jquery.tabbable");
var _find = require("lodash/find");
var _remove = require("lodash/remove");
var LazyLoad = require("./lazyload");
var WS = require('../../scripts/ws.js');
var Cookies = require('js-cookie');

var DialogContentDataAttribute = "ws-dialog-content",
    DialogTriggerSelector = `[data-${DialogContentDataAttribute}]`,
    DialogClass = "ws-dialog",
    DialogEnabledClass = "ws-dialog--enabled",
    DialogVisibleClass = "ws-dialog--visible",
    DialogCloseSelector = ".ws-dialog__close",
    DialogContentWrapperSelector = ".ws-dialog__content-wrapper",
    DialogMinimizeSelector = ".ws-chat__minimize",
    DialogMaximizeSelector = ".ws-chat__maximize",
    DialogMinimizedClass = "ws-chat-dialog__minimized",
    DialogResultsDisplayedClass = "ws-dialog--results-displayed",
    DialogUndismissableClass = "ws-dialog--undismissable",

    PopupDialogClass = "ws-dialog--size_popup",
    PopupDialogSelector = ".ws-dialog--size_popup",
    PopupDialogScrollPercent = null,

    ChatDialogClass = "ws-chat-dialog",

    MaskEnabledClass = "ws-dialog__mask--enabled",
    MaskVisibleClass = "ws-dialog__mask--visible",

    BodyScrollDisabledClass = "ws-body--scroll_disabled",
    BodyForceScrollbarClass = "ws-body--force-scrollbar",

    LifeCalcTriggerSelector = ".ws-life-calculator-modal-trigger",
    AttitudinalTypeSurveyTriggerSelector = "body:not(.pagemode-edit) .ws-attitudinal-type-survey-modal-trigger",
    AdvizrTriggerSelector = ".ws-advizr-modal-trigger",
    CalcXMLTriggerSelector = ".ws-calcxml-modal-trigger",

    Dialogs = [],
    BodyMarginTop = null,
    WindowScrollTop = null,
    EventPrefix = "ws-dialog-",
    YouTubeApiState = "unloaded",
    VideoDialogYouTubePlayers = [];

var $Window,
    $Document,
    $Body,
    $Footer,
    $Mask,

    $FamilyOfCompaniesDialog,
    $LifeCalcDialog,
    $AttitudinalTypeSurveyDialog,
    $AdvizrDialog,
    $CalcXMLDialog,
    $CalcXMLDialogBanner,
    $PopupDialog;

const Event = {
    Show: `${EventPrefix}show`,
    Hide: `${EventPrefix}hide`,
};

function YouTubePlayerControl($iframe) {
    var self = this;
    self.id = $iframe.attr('id');
    self.$iframe = $iframe;
    self.player = null;
    self.isReady = false;
    self.queuedPlayerReadyActions = [];

    self.onReady = function (e) {
        self.isReady = true;

        for (var i = 0; i < self.queuedPlayerReadyActions.length; i++) {
            self.queuedPlayerReadyActions[i]();
        }
    };

    self.queuePlayerReadyAction = function (action) {
        self.queuedPlayerReadyActions.push(action);
    };
}

function DisableBodyScrolling() {
    // if another non-popup dialog is already open, body scrolling should already be disabled
    if (Dialogs.filter(($dialog) => !$dialog.hasClass(PopupDialogClass)).length > 1) {
        return;
    }

    BodyMarginTop = $Body.css("marginTop");
    WindowScrollTop = $Window.scrollTop();
    var forceScrollbar = $Document.height() > $Window.height();

    var $stickyHeader = $(".ws-minified-header.sticky");

    $Body
        .toggleClass(BodyScrollDisabledClass, true)
        .toggleClass(BodyForceScrollbarClass, forceScrollbar)
        .css("top", `-${WindowScrollTop}px`);

    // making the body fixed can cause the sticky header to unstick; re-sticking it solves that
    if ($stickyHeader.length) {
        requestAnimationFrame(() => {
            $stickyHeader.toggleClass("sticky", true);
            $Body.css("margin-top", BodyMarginTop);

            var $minifiedHeaderWidthConstraint = $stickyHeader.find('.col-md-8.offset-md-2');
            if ($minifiedHeaderWidthConstraint.length) {
                $minifiedHeaderWidthConstraint.removeClass('col-md-8 offset-md-2');
            }
        });
    }
}

function EnableBodyScrolling() {
    // if another non-popup dialog is still open, don't enable body scrolling.
    if (Dialogs.filter(($dialog) => !$dialog.hasClass(PopupDialogClass)).length > 0) {
        return;
    }

    $Body
        .toggleClass(BodyScrollDisabledClass, false)
        .toggleClass(BodyForceScrollbarClass, false)
        .css("top", "");

    $Window.scrollTop(WindowScrollTop);
}

function DisableTabbingOutsideOfDialog() {
    if (Dialogs.length < 1) {
        return;
    }

    var $dialog = Dialogs[Dialogs.length - 1],
        hide = [],
        hideIndex,
        tabIndex,
        // Popup Dialogs should be considered part of the page and excluded from dialog heirarchy
        NonPopupDialogs = Dialogs.filter(($dialog) => !$dialog.hasClass(PopupDialogClass)),
        tabbableContext = NonPopupDialogs.length === 1 ? document : NonPopupDialogs[NonPopupDialogs.length - 2],
        tabbable = $(":tabbable", tabbableContext).toArray(),
        tabbableIndex = tabbable.length,
        dialogTabbable = $dialog.find(":tabbable").toArray();

    /* push the container on to the array */
    dialogTabbable.push($dialog.get(0));

    /* separate get attribute methods from set attribute methods */
    while (tabbableIndex--) {
        /* dont hide if element is inside the modal */
        if (dialogTabbable.indexOf(tabbable[tabbableIndex]) !== -1) {
            continue;
        }

        /* add to hide array if tabindex is not negative */
        tabIndex = parseInt(tabbable[tabbableIndex].getAttribute("tabindex"));

        if (isNaN(tabIndex)) {
            hide.push([tabbable[tabbableIndex], "inline"]);
        } else if (tabIndex >= 0) {
            hide.push([tabbable[tabbableIndex], tabIndex]);
        }
    }

    /* hide the dom elements */
    hideIndex = hide.length;

    while (hideIndex--) {
        hide[hideIndex][0].setAttribute("data-tabindex", hide[hideIndex][1]);
        hide[hideIndex][0].setAttribute("tabindex", -1);
    }
}

function RestoreTabbingOutsideOfDialog() {
    var unhide = [],
        unhideIndex,
        dataTabIndex,
        // Popup Dialogs should be considered part of the page and excluded from dialog heirarchy
        NonPopupDialogs = Dialogs.filter(($dialog) => !$dialog.hasClass(PopupDialogClass)),
        hiddenContext = NonPopupDialogs.length < 1 ? document : NonPopupDialogs[NonPopupDialogs.length - 1],
        hidden = $("[data-tabindex]", hiddenContext).toArray(),
        hiddenIndex = hidden.length;

    /* separate the get and set attribute methods */
    while (hiddenIndex--) {
        dataTabIndex = hidden[hiddenIndex].getAttribute("data-tabindex");

        if (dataTabIndex !== null) {
            unhide.push([hidden[hiddenIndex], (dataTabIndex === "inline") ? 0 : dataTabIndex]);
        }
    }

    /* unhide the dom elements */
    unhideIndex = unhide.length;

    while (unhideIndex--) {
        unhide[unhideIndex][0].removeAttribute("data-tabindex");
        unhide[unhideIndex][0].setAttribute("tabindex", unhide[unhideIndex][1]);
    }

    // This completes the ADA workaround found in ws-slick.js
    // Restore tabbing to lazyloaded Film Strip arrows missed by initial DisableTabbingOutsideOfDialog
    $(".ws-carousel--theme_film-strip .slick-arrow[data-tabindex], .ws-carousel--theme_testimonials .slick-arrow[data-tabindex]").each(function (index, element) {
        element.setAttribute("tabindex", element.getAttribute("data-tabindex"));
        element.removeAttribute("data-tabindex");
    });
}

function ResetFormState($dialog) {
    $dialog.toggleClass(DialogResultsDisplayedClass, false);
    var form = $dialog.find("form").get(0);
    if (form) {
        // need to clear input styles as well - should probably handle this in a global "reset" event handler
        form.reset();
    }
}

function FocusDialogElement() {
    if (Dialogs.length < 1 || ($(window).outerWidth() < 992 && Dialogs[0].hasClass("ws-nav"))) {
        return;
    }

    var $dialog = Dialogs[Dialogs.length - 1],
        $tabbable = $dialog.find(":tabbable"),
        $tabbableInputs = $tabbable.filter(":not(" + DialogCloseSelector + ")").filter(":input"),
        $elementToFocus = $tabbableInputs.length > 0 ? $tabbableInputs.first() : $tabbable.first();

    $elementToFocus.focus();
    $dialog.find(DialogContentWrapperSelector).scrollTop(0); // we don't want focus to cause the dialog to scroll
}

function OpenDialog($targetDialog, event, videoInfo) {
    if ($targetDialog.length) {
        Dialogs.push($targetDialog);

        if ($targetDialog.data("ws-lazyload-priority") === "high") {
            LazyLoad.unveilAllChildren($targetDialog);
        }

        var $eventTarget = event ? $(event.currentTarget) : null;
        $targetDialog
            .data("triggered-by", event ? event.currentTarget : "")
            .find(DialogContentWrapperSelector)
            .attr("tabindex", -1);

        if (event && event.preventDefault) {
            event.preventDefault();
        }

        var playerControl = GetSelectedVideoPlayerControl($targetDialog);
        if (!playerControl) {
            var $iframe = $targetDialog.find(".ws-video-iframe");
            if ($iframe.length) {
                // this is a video modal but the player hasn't been loaded for whatever reason, so force it to load
                playerControl = LoadYouTubePlayer($iframe);
            }
        }

        if (playerControl) {
            // if a start position was not provided, grab it from the triggering element, which has the video position attached to it when the dialog is closed
            if (videoInfo && !videoInfo.startSeconds) {
                videoInfo.startSeconds = $eventTarget.data("video-position") || 0;
            }

            var actionOnPlayerReady = function () {
                LoadAndPlayVideo($targetDialog, playerControl, videoInfo);
            };

            // if the player is not ready yet, queue the video up to start once it is ready
            if (playerControl.isReady) {
                actionOnPlayerReady();
            } else {
                playerControl.queuePlayerReadyAction(actionOnPlayerReady);
            }
        }

        setTimeout(function () {
            if ($targetDialog.hasClass(DialogClass)) {
                $Mask.toggleClass(MaskEnabledClass, !($targetDialog.hasClass(PopupDialogClass) || $targetDialog.hasClass(ChatDialogClass)));
                $targetDialog.toggleClass(DialogEnabledClass, true);

                requestAnimationFrame(function () {
                    $Mask.toggleClass(MaskVisibleClass, !($targetDialog.hasClass(PopupDialogClass) || $targetDialog.hasClass(ChatDialogClass)));
                    $targetDialog
                        .toggleClass(DialogVisibleClass, true)
                        .on("click", DialogCloseSelector, CloseDialog);
                });
            }

            if (!$targetDialog.hasClass(ChatDialogClass)) {
                DisableTabbingOutsideOfDialog();
            }
            

            if (!($targetDialog.hasClass(PopupDialogClass) || $targetDialog.hasClass(ChatDialogClass))) {
                DisableBodyScrolling();
            }

            FocusDialogElement();

            $Window.trigger({
                type: "ws-dialog-show",
                dialog: $targetDialog,
                originalEvent: event
            });
            $targetDialog.trigger({
                type: Event.Show,
                originalEvent: event
            });
        }, 0);
    }
}

function MinimizeChatDialog(event) {
    const $dialogInner = $(".ws-dialog__inner");
    if ($dialogInner.hasClass(DialogMinimizedClass)) {
        return;
    }

    //$(".ws-chat__inner").fadeOut(500);
    $(".ws-chat__inner").fadeOut(0);
    $(".ws-dialog__form-wrapper").fadeOut(0);
    $(".ws-chat__minimize").hide();
    $(".ws-chat__maximize").show();
    $(".ws-dialog__inner").addClass(DialogMinimizedClass);
    $(".ws-dialog__content").css({ "overflow": "hidden" });
}

function MaximizeChatDialog(event) {
    const $dialogInner = $(".ws-dialog__inner");
    if (!$dialogInner.hasClass(DialogMinimizedClass)) {
        return;
    }

    $(".ws-chat__inner").fadeIn(0);
    $(".ws-dialog__form-wrapper").fadeIn(0);
    $(".ws-chat__minimize").show();
    $(".ws-chat__maximize").hide();
    $dialogInner.removeClass(DialogMinimizedClass);
    //Just delays the css property change. Overflow is not able to be used with a css transition delay
    $(".ws-dialog__content")
        //.delay(500)
        .queue(function (next) {
            $(".ws-dialog__content").css({ "overflow": "unset" });
            next();
        });
}

function CloseDialog(event) {
    if (Dialogs.length) {
        var $dialog = Dialogs[Dialogs.length - 1];

        // Only allow close if dialog is dismissable or completed
        if ($dialog.hasClass(DialogUndismissableClass) && !$dialog.hasClass(DialogResultsDisplayedClass)) {
            return;
        }

        Dialogs.pop();
        var $trigger = $($dialog.data("triggered-by"));

        // Do not close mask if other dialogs are open UNLESS it's the Popup Dialog
        var shouldCloseMask = _find(Dialogs, ($dialogItem) => ($dialogItem.hasClass(DialogClass) && !($dialogItem.hasClass(PopupDialogClass) || $dialogItem.hasClass(ChatDialogClass)))) === undefined;

        $dialog.find(DialogContentWrapperSelector).scrollTop(0);

        if ($dialog.hasClass(DialogClass)) {
            $dialog.on("transitionend", function (e) {
                if (e.currentTarget !== e.target) {
                    return;
                }

                if (shouldCloseMask) {
                    $Mask.toggleClass(MaskEnabledClass, false);
                }

                $dialog
                    .off("transitionend")
                    .toggleClass(DialogEnabledClass, false);

                AfterClose($dialog, $trigger, event);
            });

            requestAnimationFrame(function () {
                if (shouldCloseMask) {
                    $Mask.toggleClass(MaskVisibleClass, false);
                }

                $dialog
                    .toggleClass(DialogVisibleClass, false)
                    .off("click", DialogCloseSelector, CloseDialog);

                if (!($dialog.hasClass(PopupDialogClass) || $dialog.hasClass(ChatDialogClass))) {
                    EnableBodyScrolling();
                }
            });
        } else {
            EnableBodyScrolling();
            AfterClose($dialog, $trigger, event);
        }
    }
}

function CloseAllDialogs(event) {
    // Closing the mobile mega menu should NOT close an open popup dialog
    if ($PopupDialog.length &&
        $PopupDialog.hasClass(DialogEnabledClass) &&
        event.target.className &&
        (
            (event.target.className.indexOf("ws-nav__mobile-menu-btn") !== -1) ||
            (event.target.className.indexOf("ws-megamenu__mobile-menu-btn") !== -1)
        )
    ) {
        // Find, remove, and save the popup dialog list
        var $currentPopupDialog = _remove(Dialogs, ($dialog) => $dialog.hasClass(PopupDialogClass))[0];

        while (Dialogs.length > 0) {
            CloseDialog(event);
        }

        // add popup back into dialogs list
        Dialogs.push($currentPopupDialog);
    } else {
        while (Dialogs.length > 0) {
            CloseDialog(event);
        }
    }
}

function AfterClose($dialog, $trigger, event) {
    RestoreTabbingOutsideOfDialog();
    ResetFormState($dialog);

    var playerControl = GetSelectedVideoPlayerControl($dialog);
    if (playerControl && playerControl.isReady) {
        playerControl.player.pauseVideo();
    }

    if (event && event.stopPropagation) {
        event.stopPropagation();
    }

    $Window.trigger({
        type: "ws-dialog-hide",
        dialog: $dialog,
        originalEvent: event
    });

    $dialog.trigger({
        type: Event.Hide,
        originalEvent: event
    });

    if (!$trigger.length && $dialog.hasClass(PopupDialogClass)) {
        // Return focus to <main> on Popup close instead of browser default <body>.
        // This technique allows <main> to forcibly receive focus.
        var $mainContent = $(".ws-main-content");
        $mainContent.attr("tabindex", -1);
        $mainContent.get(0).focus();
    }
    else {
        $trigger.focus();
    }

    if (playerControl && playerControl.isReady) {
        $trigger.data("video-position", playerControl.player.getCurrentTime());
    }
}

function GetSelectedVideoPlayerControl($dialog) {
    var player = null;
    var $iframe = $dialog.hasClass("ws-video-iframe") ? $dialog : $dialog.find(".ws-video-iframe");

    if ($iframe.length > 0) {
        var iframeId = $iframe.attr("id");

        player = _find(VideoDialogYouTubePlayers, function (item) {
            return item.id === iframeId;
        });
    }

    return player;
}

function LoadAndPlayVideo($dialog, playerControl, videoInfo) {
    if (videoInfo && videoInfo.url && videoInfo.url !== playerControl.player.ws_lastVideoUrl) {
        playerControl.player.loadVideoByUrl(videoInfo.url, videoInfo.startSeconds);
        playerControl.player.ws_lastVideoUrl = videoInfo.url;

        $dialog.find(".ws-video-title").html(videoInfo.title);
        $dialog.find(".ws-video-transcript").html(videoInfo.transcript);
    } else if (playerControl.player.getPlayerState() === 0) { // 0 = ENDED
        playerControl.player.seekTo(0);
    }

    playerControl.player.playVideo();
    return true;
}

function LoadYouTubeScript(readyCallbackFn) {
    // this is done before checking the API load state so that if the user clicks to play a video while the API is still loading, the video will play once loaded
    window.onYouTubeIframeAPIReady = function () {
        YouTubeApiState = "ready";
        if (readyCallbackFn && typeof readyCallbackFn === "function") {
            readyCallbackFn();
        }
    };

    if (YouTubeApiState !== "unloaded") {
        return;
    }

    YouTubeApiState = "loading";
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function LoadYouTubePlayer($iframe) {
    var playerControl = GetSelectedVideoPlayerControl($iframe);
    if (playerControl) {
        return;
    }

    playerControl = new YouTubePlayerControl($iframe);
    VideoDialogYouTubePlayers.push(playerControl);

    if (YouTubeApiState === "ready") {
        CreateYouTubePlayer(playerControl);
    } else {
        LoadYouTubeScript(() => CreateYouTubePlayer(playerControl));
    }

    return playerControl;
}

function CreateYouTubePlayer(playerControl) {
    var player = new window.YT.Player(playerControl.$iframe.attr('id'), {
        videoId: playerControl.$iframe.data('video-id'),
        events: {
            'onReady': playerControl.onReady,
            'onError': onPlayerError
        },
        playerVars: {
            host: window.location.protocol + "//www.youtube.com",
            origin: window.location.origin,
            rel: 0
        }
    });

    playerControl.player = player;
}

function onPlayerError(e) {
    console.error('Error loading YouTube player: ' + e.target.f.id);
}

function loadInlineVideoPlayer($inlineVideo) {
    $inlineVideo.toggleClass("ws-video--loaded", true);
    const $iframe = $inlineVideo.siblings('.ws-video-iframe__wrapper').find('.ws-video-iframe');
    if ($iframe.length) {
        // inline videos don't set the iframe src initially
        $iframe.attr("src", $iframe.attr("data-src") + window.location.origin);
        return LoadYouTubePlayer($iframe);
    }
}

function playInlineVideo($inlineVideo) {
    const $videoWrapper = $inlineVideo.siblings('.ws-video-iframe__wrapper');
    const $iframe = $videoWrapper.find('.ws-video-iframe');
    if ($iframe.length) {
        var playerControl = GetSelectedVideoPlayerControl($iframe) || loadInlineVideoPlayer($inlineVideo);
        if (!playerControl) {
            return;
        }

        var actionOnPlayerReady = function () {
            playerControl.player.playVideo();

            setTimeout(function () {
                $videoWrapper.toggleClass("d-none", false);
                $inlineVideo.toggleClass("d-none", true);
            }, 50);
        };

        // if the player is not ready yet, queue the video up to start once it is ready
        if (playerControl.isReady) {
            actionOnPlayerReady();
        } else {
            playerControl.queuePlayerReadyAction(actionOnPlayerReady);
        }

        // touch devices don't have hover, so we don't have the opportunity to get the YT player object ready before the click happens,
        // if we leave the placeholder image up until the YT player is ready, it appears like it's not responding
        // so for touch devices, we toggle off the placeholder image and video icon after a set time, showing the black background until the player is ready
        setTimeout(function () {
            const $placeholderImageWrapper = $(".ws-video__inline-image-wrapper");
            $placeholderImageWrapper.children().toggleClass("d-none", true);
        }, 100);
    }
}

function ScrollTriggerPopupHandler() {
    // Current Position => $Window.scrollTop()
    // Full Page Height => $Document.height()
    // Window Height    => $Window.height()
    // Footer Height    => $Footer.height()
    // Eff. Page Height => (Page Height - Window Height - Footer Height);
    var effectiveScrollPercent = ($Window.scrollTop() / ($Document.height() - $Window.height() - $Footer.height()));

    if (effectiveScrollPercent >= PopupDialogScrollPercent) {
        OpenDialog($PopupDialog);
        $Window.off("scroll", ScrollTriggerPopupHandler);
    }
}

$(function () {
    $Window = $(window);
    $Document = $(document);
    $Body = $("body");
    $Footer = $("footer.ws-footer");

    $LifeCalcDialog = $("#life-insurance-calculator-modal");
    $AttitudinalTypeSurveyDialog = $("#attitudinal-type-survey-modal");
    $AdvizrDialog = $("#advizr-modal");
    $CalcXMLDialog = $("#calcxml-modal");
    $CalcXMLDialogBanner = $CalcXMLDialog.find(".ws-calcxml-modal__buttons");
    $FamilyOfCompaniesDialog = $(".ws-dialog--family-of-companies");
    $PopupDialog = $(PopupDialogSelector);

    $Mask = $('<div class="ws-dialog__mask"></div>')
        .on("click", CloseDialog)
        .prependTo($Body);

    // Hide CTA Banner until results delivered
    $CalcXMLDialogBanner.hide();

    // iOS does not allow us to load the YouTube script and play the video in one event, so we need to load the script once the video/trigger comes into view,
    // then load the video and play it on click
    const isiOS = navigator.userAgent.match(/ipad|ipod|iphone/i);

    const $videoIframesToPreload = isiOS
        ? $(".ws-inline-video-container > .ws-video-iframe__wrapper > .ws-video-iframe, .ws-video-iframe:not(.ws-video-iframe--lazyload)")
        : $(":not(.ws-dialog__content) > .ws-video-iframe__wrapper > .ws-video-iframe:not(.ws-video-iframe--lazyload)");

    // if there are any videos on the page that require preloading (either not lazy loaded or already in the viewport on load), initialize the YouTube script
    if ($videoIframesToPreload.length) {
        LoadYouTubeScript();
    }

    $Document.on("click", DialogTriggerSelector, function (event) {
        var $target = $(event.currentTarget);
        var $targetDialog = $($target.data(DialogContentDataAttribute));

        OpenDialog($targetDialog, event);
    });

    $Document.on("click", DialogMaximizeSelector, function (event) {
        MaximizeChatDialog(event);
    });

    $Document.on("click", DialogMinimizeSelector, function (event) {
        MinimizeChatDialog(event);
    });

    if (WS.isExperienceEditor()) {
        // Handler to hide/show modal placeholders in Experience Editor
        $(".ws-dialog__ee-placeholder-dialog-toggle").on("click", function () {
            $("#" + $(this).data("target-dialog-toggle")).toggle();
        });
    } else {
        if ($PopupDialog.length) {
            PopupDialogScrollPercent = ($PopupDialog.data("scroll-percent") / 100);
            $Window.on("scroll", ScrollTriggerPopupHandler);
        }

        $(LifeCalcTriggerSelector).on("click", function (event) {
            OpenDialog($LifeCalcDialog, event);
        });

        $(AttitudinalTypeSurveyTriggerSelector).on("click", function (event) {
            OpenDialog($AttitudinalTypeSurveyDialog, event);
        });

        $(AdvizrTriggerSelector).on("click", function (event) {
            OpenDialog($AdvizrDialog, event);
        });

        $(CalcXMLTriggerSelector).on("click", function (event) {
            OpenDialog($CalcXMLDialog, event);

            // Show CTA banner when user calculates results; adjust modal accordingly
            $CalcXMLDialog.on("click", "#calc button.calculate", function () {
                $CalcXMLDialog.find(".ws-calcxml-modal__content").css("padding-bottom", $CalcXMLDialogBanner.css("height"));
                $CalcXMLDialogBanner.show();
            });
        });

        if (isiOS) {
            // find any modal trigger links that open video modals and add the lazyload class so the video initialization occurs prior to clicking the link
            // only iOS requires loading the youtube player prior to clicking on the video modal trigger
            $('[data-ws-dialog-content]:not(.lazyload):not(.lazyloaded):not(.lazyloading)').each(function (index, el) {
                const $el = $(el);
                const dialogContent = $el.data('ws-dialog-content');
                const $iframe = $(dialogContent).find('.ws-video-iframe');
                if ($iframe.length) {
                    $el.addClass("lazyload");
                }
            });

            $Document.on('lazyloaded', '[data-ws-dialog-content]', function (e) {
                const dialogContent = $(e.target).data('ws-dialog-content');
                const $iframe = $(dialogContent).find('.ws-video-iframe');
                if ($iframe.length) {
                    // the YouTube player object initialization takes a while so we preload it before the click
                    LoadYouTubePlayer($iframe);
                }
            });
        }

        $Document.on('mouseover focus touchstart', '[data-ws-dialog-content]', function (e) {
            const dialogContent = $(e.target).data('ws-dialog-content');
            const $iframe = $(dialogContent).find('.ws-video-iframe');
            if ($iframe.length) {
                // the YouTube player object initialization takes a while so we preload it before the click
                LoadYouTubePlayer($iframe);
            }
        });

        $Document.on('mouseover focus touchstart', '.ws-video--inline:not(.ws-video--loaded)', function (e) {
            loadInlineVideoPlayer($(this));
        });

        $Document.on('click', '.ws-video--inline', function (e) {
            e.preventDefault();
            playInlineVideo($(this));
        });

        $('[data-trigger-cookie-present="true"]').each(function () {
            var cookieName = $(this).data('trigger-cookie-name');

            if (Cookies.get(cookieName)) {
                OpenDialog($(this));
            }
        });

        $('[data-trigger-cookie-not-present="true"]').each(function () {
            var cookieName = $(this).data('trigger-cookie-name');

            if (typeof Cookies.get(cookieName) === 'undefined') {
                OpenDialog($(this));
            }
        });
    }
});

exports.event = Event;
exports.openDialog = OpenDialog;
exports.closeDialog = CloseDialog;
exports.closeAllDialogs = CloseAllDialogs;
exports.minimizeChatDialog = MinimizeChatDialog;
exports.maximizeChatDialog = MaximizeChatDialog;
exports.LoadYouTubePlayer = LoadYouTubePlayer;